export default class CollapseLinks {
  constructor(link) {

    // Nothing to see here if no link
    if(!link) {
      return;
    }

    this.link = link;
    this.parent = document.getElementById( this.link.dataset.target );

    if(!this.parent) {
      return;
    }

    // Add minor-delay so content can load
    setTimeout(this.setLinkWidth(), 100);
    this.updateViewport();
  }

  setLinkWidth() {
      // Get parent Width minus paddings of the element above
      const linkWidth = (this.parent.offsetWidth - 86);
      this.parent.style.setProperty('--link-width', `${linkWidth}px`);
  }

  updateViewport() {
    window.addEventListener('orientationchange', () => {
      this.setLinkWidth();
    });
    window.addEventListener('resize', () => {
      this.setLinkWidth();
    });
  }
}
